import { NotificationKey } from "@common/state/notificationState";
import { ExpenseReportStatus } from "@common/utils/graphql";
import { useMemo } from "react";

export enum EmployeeReportsSelectedTab {
  Draft = "Drafts",
  Pending = "Pending",
  Resolved = "Resolved",
}

const tabs = [
  {
    id: EmployeeReportsSelectedTab.Draft,
    name: EmployeeReportsSelectedTab.Draft.toString(),
    route: "/reports/draft",
    notificationKey: NotificationKey.ReportDraft,
  },
  {
    id: EmployeeReportsSelectedTab.Pending,
    name: EmployeeReportsSelectedTab.Pending.toString(),
    route: "/reports/pending",
    notificationKey: NotificationKey.ReportPending,
  },
  {
    id: EmployeeReportsSelectedTab.Resolved,
    name: EmployeeReportsSelectedTab.Resolved.toString(),
    route: "/reports/resolved",
    notificationKey: NotificationKey.ReportResolved,
  },
];

export const useEmployeeReportsTabs = (
  selectedTab: EmployeeReportsSelectedTab,
  setPage: (idx: number) => void,
) => {
  const status = useMemo(() => {
    setPage(0);

    switch (selectedTab) {
      case EmployeeReportsSelectedTab.Pending:
        return [ExpenseReportStatus.Pending];
      case EmployeeReportsSelectedTab.Draft:
        return [ExpenseReportStatus.Draft];
      case EmployeeReportsSelectedTab.Resolved:
        return [
          ExpenseReportStatus.Approved,
          ExpenseReportStatus.Rejected,
          ExpenseReportStatus.PartiallyApproved,
        ];
    }
  }, [selectedTab, setPage]);

  return {
    tabs,
    status,
  };
};
